import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { AffordabilityExcludedRequests } from './AffordabilityExcluded/AffordabilityExcludedRequests';
import { AffordabilityExcludedContainer, TabWrapper, Header } from './AffordabilityExcluded/AffordabilityExcludedRequests.style';
import { AffordabilityExcludedNav } from './AffordabilityExcluded/AffordabilityExcludedNav';
import { AffordabilityExcludedPag } from './AffordabilityExcluded/AffordabilityExcludedPag';

export const AffordabilityExcludedTab = observer('AffordabilityExcludedTab', () => {
    const appState = useAppStateContext();

    return (
        <>
            <AffordabilityExcludedContainer>
                <Header>Affordability Check</Header>

                <AffordabilityExcludedNav
                    affordabilityExcludedState={appState.affordabilityExcludedState}
                />

                <TabWrapper>
                    <AffordabilityExcludedRequests
                        affordabilityExcludedState={appState.affordabilityExcludedState}
                    />
                </TabWrapper>

                { appState.affordabilityExcludedState.totalItems?.total ? 
                    <AffordabilityExcludedPag
                        affordabilityExcludedState={appState.affordabilityExcludedState}
                    /> : null
                }

            </AffordabilityExcludedContainer>
        </>
    );
});
